import React, { lazy, Suspense } from 'react';
import ReactRootProviders from '@client/src/global/context/ReactRootProviders';
import { UserSessionProvider } from '@client/src/global/context/UserSessionProvider';
import { react2angular } from 'react2angular';

const PickupsMainHeaderComponent = lazy(() => import('@/pages/pickups/components/MainHeader'));

export interface PickupsMainHeaderProps {
  showScheduleButton: boolean;
}

function WrappedPickupsMainHeader({ showScheduleButton }: PickupsMainHeaderProps) {
  return (
    <ReactRootProviders>
      <UserSessionProvider>
        <Suspense fallback={null}>
          <PickupsMainHeaderComponent showScheduleButton={showScheduleButton} />
        </Suspense>
      </UserSessionProvider>
    </ReactRootProviders>
  );
}

export const AngularPickupsMainHeader = react2angular(
  WrappedPickupsMainHeader,
  ['showScheduleButton'],
  []
);
